import { h } from "preact";
import { StoryDTO } from "../model/Item";
import { Story } from "./story";

interface StoryListProps {
    stories: StoryDTO[];
}

export const StoryList = (props: StoryListProps) => {
    return <div className="story-list">
        {props.stories.map(s => Story({ story: s }))}
    </div>
}
